import axiosClient from './axiosClient';

export interface ConfigProfileDto {
  id?: number;
  name: string;
  externalServiceUrl?: string | null;
  nextcloudUrl?: string | null;
  apinformesUrl?: string | null;
  dbHost?: string | null;
  dbPort?: number | null;
  dbName?: string | null;
  isDefault?: boolean;
}

export async function listConfigProfiles(): Promise<ConfigProfileDto[]> {
  const { data } = await axiosClient.get('/config-profiles');
  return data;
}

export async function getDefaultConfigProfile(): Promise<ConfigProfileDto | null> {
  const { data } = await axiosClient.get('/config-profiles/default');
  return data;
}

/**
 * Obtiene el perfil de configuración activo desde localStorage.
 * Si no hay un perfil activo, devuelve el perfil por defecto.
 * IMPORTANTE: Siempre usar esta función para obtener el perfil correcto.
 */
export async function getActiveConfigProfile(): Promise<ConfigProfileDto | null> {
  try {
    const activeProfileName = localStorage.getItem('activeConfigProfile');
    if (activeProfileName) {
      const { data } = await axiosClient.get(`/config-profiles/${activeProfileName}`);
      return data;
    }
    // Si no hay perfil activo, usar el por defecto
    return await getDefaultConfigProfile();
  } catch (error) {
    console.error('Error al obtener perfil activo:', error);
    // Fallback al perfil por defecto en caso de error
    return await getDefaultConfigProfile();
  }
}

export async function upsertConfigProfile(payload: Partial<ConfigProfileDto>): Promise<ConfigProfileDto> {
  const { data } = await axiosClient.post('/config-profiles', payload);
  return data;
}

export async function deleteConfigProfile(name: string): Promise<void> {
  await axiosClient.delete(`/config-profiles/${encodeURIComponent(name)}`);
}

export async function testConfigConnectivity(params: {
  nextcloudUrl?: string;
  externalServiceUrl?: string;
  apinformesUrl?: string;
}): Promise<{ 
  nextcloud?: { ok: boolean; status?: number; error?: string }, 
  external?: { ok: boolean; status?: number; error?: string },
  apinformes?: { ok: boolean; status?: number; error?: string }
}> {
  const query = new URLSearchParams();
  if (params.nextcloudUrl) query.set('nextcloudUrl', params.nextcloudUrl);
  if (params.externalServiceUrl) query.set('externalServiceUrl', params.externalServiceUrl);
  if (params.apinformesUrl) query.set('apinformesUrl', params.apinformesUrl);
  const { data } = await axiosClient.get(`/config-profiles/test/connect?${query.toString()}`);
  return data;
}


